<template>
    <div class="modal fade" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div ref="modalDialog" class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content app-modal-content" style="min-height: 500px;">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('Добавление аварии') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="opened" class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="font-weight-bold text-muted">
                                    {{ $t('Название аварии') }}
                                    <strong class="text-danger">*</strong></label>
                                <input v-model="alarmTypeTitle" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="btn-group btn-block mb-2">
                                <button v-for="(item, index) in levels"
                                        :key="index"
                                        :class="{ active : currentLevelTab === item.level }"
                                        @click="currentLevelTab = item.level"
                                        class="btn btn-outline-purple position-relative">
                                    <span class="">
                                        {{ item.levelName }} ({{ countLevelConditions(item.level) }})
                                    </span>
                                    <span @click.stop="removeLevel(item)"
                                       v-if="currentLevelTab === item.level"
                                       class="text-white cursor-pointer position-absolute remove-level">x</span>
                                </button>
                            </div>
                            <div class="dropdown" v-if="unusedAlarmLevels.length">
                                <button class="btn btn-dashed-purple font-weight-bold dropdown-toggle w-100"
                                        id="dropdownMenuButton" data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        <span class="">
                                            {{ $t('Добавить уровень') }}
                                        </span>
                                </button>
                                <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton">
                                    <a v-for="item in unusedAlarmLevels"
                                       :key="item.level"
                                       @click.prevent="addLevel(item)"
                                       class="dropdown-item" href="#">
                                        {{ item.levelName }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div v-if="currentLevelConditions && currentLevelConditions.length" class="col-12 mb-4 text-center">
                            <button @click="scheduleMenuVisible = false"
                                    :class="{'btn-purple' : !scheduleMenuVisible, 'btn-outline-purple' : scheduleMenuVisible}"
                                    class="btn btn-lg">
                                <i class="fas fa-fw fa-list-ul"></i>
                                {{ $t('Условия аварии') }}
                            </button>
                            <button @click="scheduleMenuVisible = true"
                                    :class="{'btn-purple' : scheduleMenuVisible, 'btn-outline-purple' : !scheduleMenuVisible}"
                                    class="btn btn-lg ml-5">
                                <i class="far fa-fw fa-clock"></i>
                                {{ $t('Расписание уведомлений') }}
                            </button>
                        </div>
                        <div class="col-12">
                            <AlarmTypeModalLevelSchedule v-if="scheduleMenuVisible"
                                                         :levelIndex="currentLevelIndex"
                                                         :levelData="currentLevel"
                                                         @change="changeLevelSchedule"/>
                            <template v-else>
                                <AlarmTypeCondition v-for="(item, index) in currentLevelConditions"
                                                    :key="index"
                                                    :value="currentLevelConditions[index]"
                                                    :index="index"
                                                    :deviceObject="deviceObject"
                                                    :conditions="currentLevelConditions"
                                                    @change="changeConditionItem"
                                                    @remove="removeConditionItem"/>

                                <div class="btn btn-dashed-purple btn-block font-weight-bold w-100"
                                     v-if="levels.length && deviceMetrics.length"
                                     @click="addConditionItem">
                                    {{ $t('Добавить условие') }}
                                    <i class="fas fa-plus ml-1"></i>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="create"
                            :disabled="processing || !isValid"
                            style="min-width: 150px;"
                            class="btn btn-purple mx-auto">
                        <div v-if="processing" class="spinner-border spinner-border-sm text-white" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <span v-else>{{ $t('Сохранить') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import _ from "underscore";
    import $ from "jquery";
    import config from "../../config";
    import {mapState} from 'vuex';
    import AlarmTypeCondition from "../AlarmTypeCondition";
    import AlarmTypeService from "../../services/AlarmTypeService";
    import DeviceObject from "../../objects/DeviceObject";
    import AlarmTypeModalLevelSchedule from "./AlarmTypeModalLevelSchedule";

    const AlarmType = new AlarmTypeService()

export default {
    name: "AlarmTypeAddModal",
    components: {
        AlarmTypeCondition,
        AlarmTypeModalLevelSchedule
    },
    props: {
        opened: Boolean,
        deviceObject: DeviceObject
    },
    data() {
        return {
            levels: [],
            currentLevelTab: null,
            processing: false,
            alarmTypeTitle: "",
            scheduleMenuVisible: false
        }
    },
    methods: {
        removeLevel(level) {
            if (this.currentLevelConditions.length === 0 || confirm(this.$t('Удалить уровень? Так же будут удалены все условия этого уровня'))) {
                this.levels = _.reject(this.levels, item => item.level === level.level);
                this.currentLevelTab = this.levels[0]?.level;
            }
        },
        addLevel(item) {
            this.levels.push({
                conditions: [],
                schedule: ['* * * * *'],
                ...item
            });
            this.currentLevelTab = item.level;
        },
        getLevelColor(level) {
            return config.alarmLevelColors[level];
        },
        removeConditionItem(index) {
            this.levels[this.currentLevelIndex].conditions = _.reject(this.levels[this.currentLevelIndex].conditions, (item, idx) => idx === index);
        },
        changeConditionItem({index, item}) {
            this.levels[this.currentLevelIndex].conditions[index] = item;
        },
        addConditionItem() {
            this.levels[this.currentLevelIndex].conditions.push({
                metric_name: "",
                type_metric: null,
                port: null,
                type: "eq",
                value: ""
            });
        },
        countLevelConditions(level) {
            return _.find(this.levels, item => item.level === level)?.conditions?.length || 0;
        },
        changeLevelSchedule({levelIndex, cronString}) {
            this.levels[levelIndex].schedule = [cronString];
        },
        async create() {
            const createRuleConditions = _.map(this.levels, item => {
                item.level = item.level * 1;
                return item;
            })

            this.processing = true;

            const alarmType = await AlarmType.create({
                deviceId: this.deviceObject.getIRI(),
                deviceType: this.deviceObject.getType().getId(),
                title: this.alarmTypeTitle,
                level: this.level,
                createRuleConditions: createRuleConditions,
            });

            this.processing = false;

            if (alarmType) {
                this.$emit('created', alarmType);
                this.$toast.success(this.$t('Условие аварии добавлено!'));
                Object.assign(this.$data, this.$options.data());
            } else {
                this.$toast.error(this.$t('Ошибка!'));
            }
        }
    },
    computed: {
        ...mapState({
            types: state => state.types,
        }),
        deviceMetrics() {
            return this.deviceObject.getType().getMetrics();
        },
        alarmLevels() {
            return _.map(config.alarmLevels, (item, index) => {
                return {
                    level: index,
                    levelName: item
                }
            });
        },
        unusedAlarmLevels() {
            return _.filter(this.alarmLevels, item => {
                return _.pluck(this.levels, "level").indexOf(item.level) === -1;
            })
        },
        currentLevel() {
            return this.levels[this.currentLevelIndex];
        },
        currentLevelConditions() {
            return this.currentLevel?.conditions;
        },
        currentLevelIndex() {
            return _.findIndex(this.levels, item => item.level === this.currentLevelTab);
        },
        isValid() {
            const notEmptyLevels = _.every(this.levels, item => item.conditions.length > 0)
            const allConditions = _.chain(this.levels)
                .pluck("conditions")
                .flatten()
                .value()

            const isFilledConditions = _.every(allConditions, condition => {
                return condition.metric_name && condition.value !== "" && condition.type;
            });


            return this.alarmTypeTitle && allConditions.length && isFilledConditions && notEmptyLevels;
        }
    },
    watch: {
        opened(val) {
            if (val) {
                $(this.$refs.modal).modal("show");
            } else {
                $(this.$refs.modal).modal("hide");
                this.$emit("closed");
            }
        },
        currentLevelTab() {
            this.scheduleMenuVisible = false;
        }
    },
    mounted() {
        $(this.$refs.modal).on('hide.bs.modal', () => this.$emit("closed"));
    },
}
</script>

<style lang="less" scoped>
    .modal-body {
        .btn {
            font-size: 14px;
        }
    }
    .remove-level {
        top: 0px;
        right: 10px;
    }
</style>
